<template>
  <div>
    <h2 class="ViewHeading">Service</h2>
    <br />
    <b-row
      ><b-col>
        <!-- <h4>{{ this.selectedlocation }}</h4> -->
      </b-col></b-row
    >
    <b-card no-body>
      <b-tabs>
        <b-tab v-if="this.accessGroup.includes('SPX')">
          <template #title> Create Service Request </template>
          <ServiceRequest v-if="this.raisedFromText != ''"> </ServiceRequest>
        </b-tab>
        <b-tab v-if="this.accessGroup.includes('SPA')">
          <template #title> Schedule Service Appointment </template>
          <Scheduling></Scheduling>
        </b-tab>
        <b-tab v-if="this.accessGroup.includes('SPA')">
          <template #title> Modify Service Appointment </template>
          <Modify></Modify>
        </b-tab>
        <b-tab v-if="this.accessGroup.includes('SPA')">
          <template #title> View All Appointments </template>
          <!-- <b-card>
            <b-card-body class="text-center">
              <h5>You have no upcoming scheduled appointments</h5>
            </b-card-body>
          </b-card> -->
          <Scheduled> </Scheduled>
        </b-tab>
      </b-tabs>

      <!-- <b-tabs card>
        <b-tab lazy active>
          <template #title>
            Clarence Support
            <b-avatar variant="info" rounded size="1.75em">{{
              ClarenceSupportCount
            }}</b-avatar>
          </template>
          <b-card-text>
            <SupportRequestClarence></SupportRequestClarence>
          </b-card-text>
        </b-tab>
        <b-tab lazy>
          <template #title>
            AG Washbasin Unit Support
            <b-avatar variant="info" rounded size="1.75em">{{
              UnitServCount
            }}</b-avatar>
          </template>
          <b-card-text>
            <SupportRequestWashbasin></SupportRequestWashbasin>
          </b-card-text>
        </b-tab>
        <b-tab lazy>
          <template #title>
            Water Management Support
            <b-avatar variant="info" rounded size="1.75em">{{
              WaterManagementCount
            }}</b-avatar>
          </template>
          <b-card-text>
            <SupportWaterManagement></SupportWaterManagement>
          </b-card-text>
        </b-tab>
        <b-tab lazy>
          <template #title>
            Service Tickets
            <b-avatar variant="info" rounded size="1.75em">{{
              UnitSupportCount
            }}</b-avatar>
          </template>
          <b-card-text>
            <ServiceRequests></ServiceRequests>
          </b-card-text>
        </b-tab>
      </b-tabs> -->
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import {} from "bootstrap-vue";
import ServiceRequest from "../components/ServiceClient.vue";
import Scheduling from "../components/Scheduling.vue";
import Scheduled from "../components/ScheduledLocation.vue";
import Modify from "../components/ModifyService.vue";

// import SupportRequestClarence from "./SupportRequestClarence.vue";
// import SupportRequestWashbasin from "./SupportRequestWashbasin.vue";
// import SupportWaterManagement from "./SupportWaterManagement.vue";
// import ServiceRequests from "./ServiceRequest.vue";

export default {
  computed: {},
  components: {
    // SupportRequestClarence,
    // SupportRequestWashbasin,
    // SupportWaterManagement,
    // ServiceRequests,
    ServiceRequest,
    Scheduling,
    Scheduled,
    Modify,
  },

  data() {
    return {
      accessGroup: localStorage.getItem("accessGroup"),
      file: "",
      DeviceID: "123456789",
      Folder: "attachments",
      items: [],
      UserHeaders: [],
      response: null,
      ArrTest: [],
      perPage: 5,
      currentPage: 1,
      rowDblClickHandler: "",
      modal: false,
      item0: "",
      item1: "",
      item2: "",
      item3: "",
      item4: "",
      showOverlay: false,
      duplicatefile: false,
      fields2: ["OutletID", "OutletDesc", "show_details"],
      items2: [
        {
          isActive: true,
          OutletID: 40,
          OutletDesc: "Shower",
          last_flush: "10/10/2022",
        },
        {
          isActive: false,
          OutletID: 21,
          OutletDesc: "Hot Tap",
          last_flush: "11/10/2022",
        },
        {
          isActive: false,
          OutletID: 89,
          OutletDesc: "Cold Tap",
          last_flush: "09/08/2022",
          _showDetails: true,
        },
        {
          isActive: true,
          OutletID: 38,
          OutletDesc: "Shower",
          last_flush: "10/10/2022",
        },
      ],
      selectedlocation: localStorage.getItem("CurrentLocation"),
      ClarenceSupportCount: "",
      UnitServCount: "",
      WaterManagementCount: "",
      UnitSupportCount: "",
      raisedFromText: "",
    };
  },

  beforeMount() {},

  mounted() {
    this.raisedFromText = "Super User Admin";
    let RaiseID = "N/A";
    Vue.prototype.$RaisedFromID = RaiseID;
    Vue.prototype.$RaisedFrom = this.raisedFromText;
  },
  methods: {
    getUserInitials() {
      this.userInitials = localStorage.getItem("UserInitials");
      return this.userInitials;
    },
    userfullname() {
      this.userfullname = localStorage.getItem("fullname");
      return this.userfullname;
    },
    handleFileUpload() {
      this.file = event.target.files[0];
    },
    submitFile() {
      this.isExist();
      if (this.file == "") {
        alert("Please select a file to upload");
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      }
      if (this.file.size > 2000000) {
        alert("file selected is too large, maximum file size is 2mb");
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      }
      if (this.duplicatefile == true) {
        alert(
          "File with this name already exists, uploading will overwrite current file. Please delete existing file or change name of file to be uploaded."
        );
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      } else {
        this.uploadFile(this.file);
      }
    },

    isExist: function() {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i][3] == this.file.name) {
          this.duplicatefile = true;
          return true;
        }
      }
      this.duplicatefile = false;
      return false;
    },

    cancelChooseFile() {
      alert("File Upload Cancelled");
      this.file = "";
      document.getElementById("file-upload").value = null;
    },

    //async onRemoveFile(event) {
    //let url = "attachments" + '/' + event.file.name // event.file.name has only the name after the slash / so the actual filename
    //const res = await deleteObjectByKey(url)
    // if (
    //  res.$response.httpResponse.statusCode >= 200 &&
    //  res.$response.httpResponse.statusCode < 300
    // ){
    // here remove data from database too
    //  }
    // },

    submitFileToDB(FileSave, FileLocation) {
      this.SubmitUserURN = this.$UserURN;
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/attachments";
      let LookUpHeaders = this.$apikeyPost;

      this.LookUpRequest = {
        RequestType: "Create",
        RequestVariable: "",
        DataDict: [
          {
            DeviceID: this.DeviceID,
            FileName: FileSave,
            FileURL: FileLocation,
            UploaderURN: this.SubmitUserURN,
          },
        ],
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          this.refreshTable();
        });
    },

    showActionModal(var0, var1, var2, var3, var4) {
      this.item0 = var0;
      this.item1 = var1;
      this.item2 = var2;
      this.item3 = var3;
      this.item4 = var4;
      this.$refs["DeviceAttachModal"].show(
        this.item0,
        this.item1,
        this.item2,
        this.item3,
        this.item4
      );
    },

    resetValue() {
      this.file = "";
      document.getElementById("file-upload").value = null;
    },

    DeleteAttachment(delvar1) {
      this.DeleteUserURN = this.$UserURN;
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/attachments";
      let LookUpHeaders = this.$apikeyPost;

      this.LookUpRequest = {
        RequestType: "Delete",
        RequestVariable: delvar1,
        DataDict: [
          {
            ClearedURN: this.DeleteUserURN,
          },
        ],
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          this.$refs["DeviceAttachModal"].hide();
          this.refreshTable();
        });
    },
    resetmodal() {
      this.$refs["DeviceAttachModal"].hide();
    },
    refreshTable() {
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/attachments";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "LoadAll",
        RequestVariable: this.DeviceID,
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          this.testing = response.data.field_names;
          this.items = response.data.Values;
          for (let i = 0; i < this.testing.length; i++) {
            var QuoteStr = "" + i + "";
            this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
          }
          this.UserHeaders = this.ArrTest;
          this.UserHeaders.push("Action");
          this.ArrTest = [];
        });
    },
  },
};
</script>

<style>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid cadetblue;
  border-radius: 5px;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  color: cadetblue;
}

#Table {
  margin: auto;
  text-align: center;
}

#cancel-label {
  color: white;
  font-size: large;
}

.Upload label {
  font-size: 15px;
}

.modal {
  text-align: center;
}
</style>
